import { IState } from '../../../../store';

export function selectIsBlackFridayExclusive(state: IState): boolean {
  return Boolean(state.offerData.offer.blackFriday?.isExclusive);
}
